import React, { useEffect } from 'react';
import EnhancedProjectsHeader from '../components/EnhancedProjectsHeader';
import CaseStudiesSection from '../components/CaseStudiesSection';
import IndustryApplicationsSection from '../components/IndustryApplicationsSection';
import ProjectCtaSection from '../components/ProjectCtaSection';
import ProjectsGallerySection from '../components/ProjectsGallerySection';
import ProjectProcessSection from '../components/ProjectProcessSection';
import '../styles/modern.css';

const ProjectsPage = () => {
  useEffect(() => {
    // Enable smooth scrolling for page
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Initialize animations
    const fadeElems = document.querySelectorAll('.fade-in');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    
    fadeElems.forEach(elem => observer.observe(elem));
    
    return () => {
      fadeElems.forEach(elem => observer.unobserve(elem));
    };
  }, []);

  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="modern-site">
      <EnhancedProjectsHeader />
      <ProjectsGallerySection />
      <ProjectProcessSection />
      <CaseStudiesSection />
      <IndustryApplicationsSection />
      <ProjectCtaSection />
    </div>
  );
};

export default ProjectsPage;
